import Vue from 'vue'
import {
  Loading,
  Button,
  Table,
  TableColumn,
  Input,
  InputNumber,
  Checkbox,
  Form,
  FormItem,
  Scrollbar,
  MessageBox,
  Message,
  Dialog,
  Select,
  Option,
  Row,
  Col,
  Pagination,
  DatePicker,
  Tooltip
} from 'element-ui'
import BasicButton from '../components/basic/basic-button.vue'

Vue.use(Button)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Checkbox)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Scrollbar)
Vue.use(Dialog)
Vue.use(Select)
Vue.use(Option)
Vue.use(Row)
Vue.use(Col)
Vue.use(Pagination)
Vue.use(DatePicker)
Vue.use(Tooltip)
Vue.use(Loading.directive)

Vue.component('BasicButton', BasicButton)

Vue.prototype.$loading = Loading.service
Vue.prototype.$elConfirm = MessageBox.confirm
Vue.prototype.$elMessage = Message



// WEBPACK FOOTER //
// ./src/plugins/element-ui.js